export const setCookie = (cname, cvalue, exdays) => {
    if (exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    } else {
        document.cookie = cname + "=" + cvalue + "; path=/";
    }
};

export const getCookie = (cname) => {
    const name = cname + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

export const scrollToTarget = (id) => {
    // target element
    const element = document.querySelector(id);
    const headerHeight = document.querySelector(
        ".global-header-container",
    ).clientHeight;
    const pos = element.offsetTop - headerHeight;

    // animated top scrolling
    scroll({ top: pos, left: 0, behavior: "smooth" });
    //set focus
    const firstElement = element.querySelector("input, button, a");
    if (firstElement) {
        firstElement.focus({ preventScroll: true });
    }
};

export const expand = (element) => {
    if (element.classList.contains("_js-accordion-trigger")) {
        element.classList.add("is-active");
        element.setAttribute("aria-expanded", "true");
    } else {
        const trigger = element.closest("._js-accordion-trigger");
        if (trigger) {
            trigger.classList.add("is-active");
            trigger.setAttribute("aria-expanded", "true");
        }
    }
};

export const displayCartStatus = () => {
    let sizetext;
    const boughtSizeD = Array.from(
        document.querySelectorAll("._jsSizeSelector"),
    );
    if (boughtSizeD[0].nodeName === "OPTION") {
        const dropdown = document.querySelector("._js-size-dropdown");
        sizetext =
            "Størrelse: " + dropdown.options[dropdown.selectedIndex].innerText;
    } else {
        boughtSizeD
            .filter((node) =>
                node.nextElementSibling.matches(".select-size__trigger"),
            )
            .forEach((node) => {
                if (node.matches(":checked")) {
                    sizetext =
                        "Størrelse: " + node.nextElementSibling.innerText;
                }
            });
    }
    document.querySelector("._js-cart-status-size").innerText = sizetext;

    const status = document.querySelector("._js-cart-status");
    status.classList.add("is-active");
    status.setAttribute("aria-hidden", false);

    document.querySelector("._js-cart-status-tocart").focus();
    Array.from(document.querySelectorAll("._js-cart-status-close")).forEach(
        (node) =>
            node.addEventListener("click", () => {
                status.classList.remove("is-active");
                status.setAttribute("aria-hidden", true);
                document.querySelector("._js-add-to-cart").focus();
            }),
    );
};

export const formatNumber = (number) => number.toLocaleString("nb-NO"); //Adds space as thounsand separator
